import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DeleteButton from "./delete-button";
import LookupElements from "./lookup-elements";
import { useMediaQuery, useTheme } from '@mui/material';

const CommonRow = ({ row, removeRow, open, setOpen }) => {

    const theme = useTheme();
    const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <TableRow>
            
            {!isXlUp && (
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            )}
            
            <TableCell component="th" scope="row">
                {row.serialNumber}
            </TableCell>

            {!isSmDown && (
                <TableCell align="right">{row.version}</TableCell>
            )}

            {!isLgDown && (
                <TableCell align="right">{row.oem}</TableCell>
            )}

            {!isLgDown && (
                <TableCell align="right">{row.type}</TableCell>
            )}

            {!isMdDown && (
                <TableCell align="right">{row.voltage}</TableCell>
            )}

            {!isMdDown && (
                <TableCell align="right">{row.boudrate}</TableCell>
            )}

            {!isXsDown && (
                <TableCell align="right">
                    <LookupElements row={row}></LookupElements>
                </TableCell>
            )}

            {!isXlUp && (
            <TableCell />
            )}

            {!isXlUp && (
            <TableCell />
            )}

            <TableCell align="right">
                <DeleteButton row={row} removeRow={removeRow}></DeleteButton>
            </TableCell>
            
        </TableRow>
    );
};

export default CommonRow;